import React, { useEffect, useState } from 'react'
import { RecommendationProductsTemplate } from './RecommendationProductsTemplate'
import {
  GetSimilarsByProductIdResponse,
  getSimilarsByProductId,
} from '@/checkout-instore-legacy/services/CatalogService'
import { getDefaultSeller } from '@/checkout-instore-legacy/seller/utils'
import { getDefaultImage } from '@/checkout-instore-legacy/utils/CatalogUtils'
import compact from 'lodash/compact'
import head from 'lodash/head'
import { WithRouterProps } from 'react-router'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { sendMetric } from '@/checkout-instore-legacy/VtexLakeHouse'
import {
  MetricAction,
  MetricShowcase,
} from '@/checkout-instore-legacy/VtexLakeHouse/typings'
import { RecommendationProduct } from '@/checkout-instore-legacy/product/typings'

const getNormalizedSimilarProducts = (
  similarProductsResponse: GetSimilarsByProductIdResponse
): RecommendationProduct[] => {
  return similarProductsResponse.map((similarProduct) => {
    const defaultSku =
      compact(similarProduct.items).find((sku) => {
        return (
          getDefaultSeller(sku.sellers)?.commertialOffer?.availableQuantity > 0
        )
      }) ?? head(similarProduct.items)

    const defaultSeller = getDefaultSeller(defaultSku?.sellers)

    return {
      id: similarProduct.id,
      skuId: defaultSku?.id ?? '',
      description: similarProduct.description,
      name: similarProduct.name,
      imageUrl: getDefaultImage(defaultSku),
      isTakeAwayAvailable: false,
      listPrice: defaultSeller.commertialOffer.listPrice,
      price: defaultSeller.commertialOffer.price,
    }
  })
}

export type SimilarProductsSectionProps = {
  productId: string
  // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
} & WithRouterProps

export const SimilarProductsSection = withRouter(
  ({ router, productId }: SimilarProductsSectionProps) => {
    const [similarProductsList, setSimilarProductsList] = useState<
      RecommendationProduct[]
    >([])

    const handleProductClick = async (
      clickedProduct: RecommendationProduct
    ) => {
      sendMetric({
        action: MetricAction.ProductSuggestionClick,
        showcase: MetricShowcase.SimilarProducts,
        product_id: productId,
        clicked_product_id: clickedProduct.id,
      })
      router.push({
        pathname: `/product/${clickedProduct.id}`,
        query: {
          skuId: clickedProduct.skuId,
          origin: productId,
        },
      })
    }

    useEffect(() => {
      getSimilarsByProductId(productId).then((response) => {
        setSimilarProductsList(getNormalizedSimilarProducts(response))
      })
    }, [productId])

    if (!similarProductsList.length) {
      return null
    }

    return (
      <RecommendationProductsTemplate
        productsList={similarProductsList}
        onProductClick={handleProductClick}
      />
    )
  }
)
